import React, { FC } from 'react'

import InputItem from '../../../components/InputItem'
import { ITabBaseProps } from './types'

export const GenericEmissions: FC<ITabBaseProps> = ({ formik }) => {
  return (
    <div className="piece-content-inputs mb-5">
      <InputItem
        name="FLAG Net Carbon Emissions"
        description="FLAG carbon emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag.l0_NetCarbon"
        showAsterisk
        formik={formik}
        defaultValue={formik.values.flag.l0_NetCarbon === 0 ? '0' : formik.values.flag.l0_NetCarbon}
      />
      <InputItem
        name="Total Land Use Change Emissions"
        description="Please provide emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag.l1_LandUseChangeCarbon"
        formik={formik}
        showAsterisk
        defaultValue={
          formik.values.flag.l1_LandUseChangeCarbon === 0
            ? '0'
            : formik.values.flag.l1_LandUseChangeCarbon
        }
      />
      <InputItem
        name="Total Land Management, CO2 Emissions"
        description="Please provide carbon emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag.l1_LandManagementCarbon"
        formik={formik}
        showAsterisk
        defaultValue={
          formik.values.flag.l1_LandManagementCarbon === 0
            ? '0'
            : formik.values.flag.l1_LandManagementCarbon
        }
      />
      <InputItem
        name="Total Land Management, Non-CO2 Emissions"
        description="Please provide emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        showAsterisk
        formikName="flag.l1_LandManagementNonCarbon"
        formik={formik}
        defaultValue={
          formik.values.flag.l1_LandManagementNonCarbon === 0
            ? '0'
            : formik.values.flag.l1_LandManagementNonCarbon
        }
      />
      <InputItem
        name="Total Non-land Emissions"
        description="Please provide emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        showAsterisk
        formikName="flag.l1_NonLandCarbon"
        formik={formik}
        defaultValue={
          formik.values.flag.l1_NonLandCarbon === 0 ? '0' : formik.values.flag.l1_NonLandCarbon
        }
      />
      <InputItem
        name="Total Unverified Removals"
        description="Please provide emissions removed in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        showAsterisk
        formikName="flag.l1_UnverifiedRemovalsCarbon"
        formik={formik}
        defaultValue={
          formik.values.flag.l1_UnverifiedRemovalsCarbon === 0
            ? '0'
            : formik.values.flag.l1_UnverifiedRemovalsCarbon
        }
      />
      <InputItem
        name="Total Verified Removals"
        description="Please provide emissions removed in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        showAsterisk
        formikName="flag.l1_VerifiedRemovalsCarbon"
        formik={formik}
        defaultValue={
          formik.values.flag.l1_VerifiedRemovalsCarbon === 0
            ? '0'
            : formik.values.flag.l1_VerifiedRemovalsCarbon
        }
      />
    </div>
  )
}

export default GenericEmissions
